import {ErrorMessage, Field, FieldProps, Form, FormikProps, withFormik} from 'formik'
import {FieldInput} from '../../molecules/FieldInput'
import * as React from 'react'
import styled from 'styled-components'
import {P} from '../../atoms/P'
import {media} from '../../utils/media'
import {Button} from '../../atoms/Button'
import {FieldError} from '../../atoms/FieldError'
import {Alert} from '../../atoms/Alert'
import {ApolloError} from 'apollo-client'
import moment from 'moment'

export interface IFormValues {
  occupation: string
  userId: number
}

export interface IViewProps {
  is: null | 'filling' | 'ready' | 'error'
  error: null | ApolloError
  doSubmitForm: (values: IFormValues) => void
}

const HcpWelcomeFormViewInner = ({is, error, isValid}: FormikProps<IFormValues> & IViewProps) => (
  <Form>
    <P style={{marginTop: 40, fontSize: 20}}>Your Occupation</P>
    <SelectOccupation>
      <OccupationBlock>
        <Field name="occupation" value="anesthesiologist"
               component={RadioInput} type="radio"/>
        <P>Anesthesiologist</P>
      </OccupationBlock>
      <EmptyBlock/>
      <OccupationBlock>
        <Field name="occupation" value="operation room nurse"
               component={RadioInput} type="radio"/>
        <P>Nurse</P>
      </OccupationBlock>
    </SelectOccupation>
    <ErrorMessage name="occupation" component={FieldError}/>
    <P style={{fontSize: 20}}>Patient Information</P>
    <NameRow>
      <Field name="userId" placeholder="User ID" type="number" component={FieldInput}/>
    </NameRow>
    <ErrorMessage name="userId" component={FieldError}/>
    {is === 'error' && <Alert>{error.graphQLErrors[0].message}</Alert>}
    <div style={{marginTop: 61, justifyContent: 'center', display: 'flex'}}>
      <Button disabled={!isValid} type="submit">Submit</Button>
    </div>
  </Form>
)

const RadioInput = ({field, form, ...props}: FieldProps & React.InputHTMLAttributes<HTMLInputElement>) => {
  return (
    <Container>
      <Input {...field} {...props} type="radio"/>
      <CheckMark/>
    </Container>
  )
}

export const HcpWelcomeFormView = withFormik<IViewProps, IFormValues>({
  handleSubmit: async (values, {props, setErrors}) => {
    await props.doSubmitForm(values)
  },
  validate: (values) => {
    const errors = {occupation: '', userId: ''}
    if (!values.occupation) {
      errors.occupation = 'Please select one occupation'
    }
    if (!values.userId) {
      errors.userId = 'Please enter patient\'s user ID'
    }
    const isEmpty = Object.values(errors).every(error => (error === ''))
    if(isEmpty) {
      return {}
    } else {
      return errors
    }
  },
  isInitialValid: false,
})(HcpWelcomeFormViewInner)

const SelectOccupation = styled.div`
  @media (min-width: 400px) {
  display: flex;
  }
`

const EmptyBlock = styled.div`
  margin: 0 20px 0 20px;
`

const EmptyNameBlock = styled.div`
  margin: 14px 0;
  ${media.tablet`
    margin: 0 40px 0 40px;
  `}
`

const OccupationBlock = styled.div`
  align-items: center;
  display: flex;
`

const EmptyDateBlock = styled.div`
  margin: 14px 0;
  @media (min-width: 300px) {
    margin: 0 10px 0 0;
  }
`

const NameRow = styled.div`
  ${media.tablet`
    display: flex;
  `}
`

const DateRow = styled.div`
  width: 85px;

  @media (min-width: 300px) {
    display: flex;
    width: 250px;
  }
`

const Input = styled.input`
  opacity: 0;
  z-index: -1;
`

const CheckMark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 30px;
  width: 30px;
  border: solid 1px #bab4ce;
  border-radius: 50%;
  background-color: white;
`

const Container = styled.label`
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  ${Input}:checked ~ ${CheckMark}:after {
   display: block;
  }

  ${CheckMark}:after {
   content:"";
   position: absolute;
   top: 5px;
   left: 5px;
   width: 18px;
   height: 18px;
   border-radius: 50%;
   background: #FA8D2D;
   display: none;
  }
`



// WEBPACK FOOTER //
// ./src/organisms/HCP_Welcome/HCP_WelcomeFormView.tsx